// extracted by mini-css-extract-plugin
module.exports = {"content":"Popup_content__17San","svg":"Popup_svg__1laHl","percents":"Popup_percents__3II4D","flex":"Popup_flex__2WluS","value":"Popup_value__1DH5x"};